module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Medium.fcf9fdb0.woff2";